import { Component, OnInit } from '@angular/core';
import { SOPT_INCREASE_ACH_PAYMENT_SUCCESS_MSG, SPOT_INCEASE_DECREASE_SUCCSESS_MSG, USER_ROLES } from '@shared/constant/shared.constant';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { DriverService } from '../driver/services/driver.service';
import { SpotCountUpdateService } from '@core/services/spot-count-update.service';
import { ToastService } from '@shared/services/toast.service';
import { SpotCountUpdateSuccessModalComponent } from '../spot-count-update-success-modal/spot-count-update-success-modal.component';
import { CommonFunctions } from '@shared/common-functions';

@Component({
  selector: 'app-spot-count-update-payment-modal',
  templateUrl: './spot-count-update-payment-modal.component.html',
  styleUrls: ['./spot-count-update-payment-modal.component.scss']
})
export class SpotCountUpdatePaymentModalComponent implements OnInit{
  driverId: string;
  bookingType: number;
  bookingId: string;
  paymentMethodDetails: any[];
  paymentMethodSelected: any;
  prefereedPaymentMethodId: string;
  displayedPaymentMethods: any[];
  viewMore: boolean;
  updatedBookingData: any;
  isPaymentMethodValid: boolean = false;
  previouslySelectedPaymentMethod: any;
  previousPaymentMethodCardAch: null;
  isPreferredPaymentSelected: boolean = true;
  selectedPaymentMethod: any = null;
  updatedPaymentMethod: any;
  userRoles = USER_ROLES;
  assisstedListUrl: string;
  userType: any;
  decreaseSpotFrom: number;
  noOfSlots: number;
  spotChnageType: number;

  constructor(
    public config: DynamicDialogConfig,
    private readonly driverService: DriverService,
    private readonly ref: DynamicDialogRef,
    private readonly spotCountUpdateService: SpotCountUpdateService,
    private readonly toastService: ToastService,
    private readonly dialogControlService: DialogControlService
  ) { }

  ngOnInit() {
    this.updatedBookingData = this.config?.data?.data;
    this.decreaseSpotFrom = this.config?.data?.decreaseSpotFrom;
    this.noOfSlots = this.config?.data?.noOfSlots;
    this.spotChnageType = this.config?.data?.spotUpdateType;
    this.bookingType = this.updatedBookingData.bookingType;
    this.driverId = this.updatedBookingData.driverId;
    this.bookingId = this.config.data.bookingId;
    this.getAllPaymentList(this.driverId);
  }

  getAllPaymentList(DriverId) {
    this.driverService.getAllPatmentMethodsList(DriverId).subscribe({
      next: (response) => {
        const cards = response.data['cards'] || [];
        if (cards.length === 0) 
          {
            this.isPreferredPaymentSelected = false;
          }
       
        let defaultPayment = [...cards].find(payment => payment.isDefaultPaymentMethod);
        this.paymentMethodDetails = [...cards];
        if (defaultPayment) {
          this.paymentMethodDetails = this.paymentMethodDetails.filter(
            (p) => p !== defaultPayment
          );
          this.paymentMethodDetails.unshift(defaultPayment);
        }
        this.paymentMethodSelected = defaultPayment || null;
        this.updateDisplayedPayments();
        this.prefereedPaymentMethodId = this.paymentMethodSelected?.id;
        this.updatedPaymentMethod = (this.paymentMethodSelected?.type === 'us_bank_account') ? 2 : (this.paymentMethodSelected?.type === 'card') ? 1 : null;
        
        if (defaultPayment?.isDefaultPaymentMethod) {
          this.updatePaymentDetails();
        }
      },
      error: (_error) => {
        this.displayedPaymentMethods = [];
        this.isPreferredPaymentSelected = false;
      },
    });
  }

  close():void {
    this.ref.close();
  }

  viewMoreToggal() {
    this.viewMore = !this.viewMore;
    this.updateDisplayedPayments();
  }

  updateDisplayedPayments() {
    this.displayedPaymentMethods = this.viewMore
      ? this.paymentMethodDetails // Show all if "View More" is clicked
      : this.paymentMethodDetails.slice(0, 2); // Show only first 2 items initially
  }

  onPreferredCheck(data) {
    this.isPaymentMethodValid = false;
    if (!data) {
      this.updatedPaymentMethod = null;
      this.previouslySelectedPaymentMethod = this.paymentMethodSelected;
      this.prefereedPaymentMethodId = null;
      if (this.previousPaymentMethodCardAch != null) {
        this.updatedPaymentMethod = this.previousPaymentMethodCardAch;
      }
    } else {
      if (this.previouslySelectedPaymentMethod) {
        this.paymentMethodSelected = this.previouslySelectedPaymentMethod;
        this.prefereedPaymentMethodId = this.previouslySelectedPaymentMethod.id;
        this.updatedPaymentMethod = this.previouslySelectedPaymentMethod.type === 'card' ? 1 : 2;
      }
    }
    this.updatePaymentDetails();
  }

  getSelectedPaymentMethod(data) {
    this.previousPaymentMethodCardAch = data;
    this.selectedPaymentMethod = data;
    this.updatedPaymentMethod = data;
    this.isPaymentMethodValid = false;
    this.updatePaymentDetails();
  }

  onPaymentChange(event) {
    if (this.isPreferredPaymentSelected) {
      this.paymentMethodSelected = event;
      this.prefereedPaymentMethodId = event.id;
    }
    this.updatedPaymentMethod = event.type === 'card' ? 1 : 2;
    this.isPaymentMethodValid = false;
    this.updatePaymentDetails();
  }

  updatePaymentDetails(): void {
    let request = {
      bookingId: this.bookingId,
      noOfSlots: this.noOfSlots,
      spotUpdateType: this.spotChnageType,
      decreaseSpotFrom: this.decreaseSpotFrom,
      PaymentMethodId: this.isPreferredPaymentSelected ? this.prefereedPaymentMethodId : null,
      PaymentMethodType: this.updatedPaymentMethod
    }

this.spotCountUpdateService.CheckValidityOnSpotCountIncreaseDecrease(request).subscribe({
      next: (response) => {
        
        this.updatedBookingData = response?.data;
      }
    })
  }

  payNowButton() {
    if (this.updatedPaymentMethod) {
      
      let request = {
        bookingId: this.bookingId,
        noOfSlots: this.noOfSlots,
        spotUpdateType: this.spotChnageType,
        increaseSpotFrom: this.decreaseSpotFrom,
        paymentMethod: this.updatedPaymentMethod,
        isPreferredPaymentMethod: this.isPreferredPaymentSelected ? true : false,
        preferredPaymentMethodId: this.isPreferredPaymentSelected
          ? this.prefereedPaymentMethodId
          : null,
      };
      this.spotCountUpdateService.increaseGroupBookingSpot(request).subscribe({
        next: (response: any) => {
          
          if (response.data?.url) {
            window.location.href = response.data?.url;
          } else {
            this.openSuccessModal(response);
          }
          this.close();
        },
        error: (_error: any) => {
          
          this.toastService.showToastMessage('error', 'Error', _error.error.message)
        },
      });
    } else {
      this.isPaymentMethodValid = true;
       CommonFunctions.gotoTop();
    }

  }

  openSuccessModal(data): void {
    let heading: string = '';
    let bodyText: string = '';

    if (data.data.paymentMethod === 2) {
      heading = 'Payment Initiated';
      bodyText = SOPT_INCREASE_ACH_PAYMENT_SUCCESS_MSG
    } else {
      bodyText = SPOT_INCEASE_DECREASE_SUCCSESS_MSG;
    }
    this.dialogControlService.openDialog(SpotCountUpdateSuccessModalComponent, {
      width: '20%',
      data: {
        heading: heading,
        bodyText: bodyText,
        isSpotUpdate: true,
        bookingId: this.updatedBookingData.bookingId,
        groupUserId: this.updatedBookingData?.groupUserId,
        spotCount: this.updatedBookingData?.currentSpot,
      },
    });
  }
}
